import React from "react";
import { Chip } from "react-native-paper";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { PickerFieldWrapper } from "./PickerFieldWrapper";
import { RootStackParamList } from "../../types/navigationParams";
import { Field } from "../../config/companies/config";

interface CollectionPickerFieldProps {
  field: Field;
  value: any;
  onChange: (fieldName: string, newValue: any) => void;
  errors?: { [key: string]: string };
  formData: any;
}

export const CollectionPickerField = ({
  field,
  value,
  onChange,
  errors = {},
  formData,
}: CollectionPickerFieldProps) => {
  const navigate = useNavigation<NavigationProp<RootStackParamList>>();

  const handleChangeRemoteListDropdown = (newValue: any) => {
    if (field?.objectFields) {
      const data = newValue.map((element: any) => {
        const newObject: { [key: string]: any } = {};
        field.objectFields?.forEach((objField) => {
          newObject[objField] = element[objField];
        });
        return newObject;
      });
      return onChange(field.name, data);
    }
    onChange(field.name, newValue);
  };

  const onPressPicker = () =>
    navigate.navigate("CollectionPickerScreen", {
      onValueChange: handleChangeRemoteListDropdown,
      selectedOptions: field.multiselect ? formData[field.name] : [],
      formData: formData,
      collection: field.collection || "",
      key: field.key || "",
      secondKey: field.secondKey,
      thirdKey: field.thirdKey,
      autoCapitalize: field.autoCapitalize,
      multiselect: field.multiselect,
      showAdd: field.showAdd,
      onlyCompany: field.onlyCompany,
      where: field.where,
      clientFilter: field.clientFilter,
    });

  const renderChip = (item: any, index: number) => (
    <Chip
      key={index}
      onClose={() => {
        const newValue = value.filter(
          (selectedItem: any) => selectedItem.id !== item.id,
        );
        onChange(field.name, newValue);
      }}
    >
      {item[field.key || ""]}
    </Chip>
  );

  return (
    <PickerFieldWrapper
      field={field}
      value={value}
      onChange={onChange}
      onPress={onPressPicker}
      errors={errors}
      displayValue={
        typeof value === "string"
          ? value
          : value?.[field.key || ""] || ""
      }
      renderChip={field.multiselect ? renderChip : undefined}
    />
  );
};
